module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008_Acknowledgements#fm-1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Abbreviations#fm-2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fm-3"
    }
  }, [_c('strong', [_vm._v("Introduction: The role of the Psalms in the life of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-1"
    }
  }, [_vm._v("The nature and purpose of this book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-2"
    }
  }, [_vm._v("A preview of the book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Part01#pt-1"
    }
  }, [_vm._v("Part 1"), _c('br'), _c('strong', [_vm._v("ISSUES IN READING THE PSALMS AND THE PSALTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("1"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("What is a psalm?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-3"
    }
  }, [_vm._v("Titles for the book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-4"
    }
  }, [_vm._v("How many psalms?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-5"
    }
  }, [_vm._v("Anatomy of a psalm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-6"
    }
  }, [_vm._v("Collections and clusters of psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#sec-7"
    }
  }, [_vm._v("The structure of the book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("It’s poetry!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is poetry and why is it important?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Important terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What makes the Psalms poetry?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Did David write the Psalms?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claims of Davidic authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questioning David as author of the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 72 as turning point in Davidic authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figurative readings of David in the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If not David, then who?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recovering David in the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("A psalm for every occasion: types of psalms")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalms study in the twentieth century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hermann Gunkel and the rise of form criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Settings for performance of the Psalms")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultic setting of the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imagining the Psalms in worship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Specific theories of cultic settings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Re-use of cultic psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2"), _c('br'), _c('strong', [_vm._v("READING THE PSALMS TOGETHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("Going by the book: the Psalter as a guide to reading the psalms")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signs of coherence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going further: the theological shape of the Psalter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("The theology of the Psalms, Part 1: ‘The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" reigns!’")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s kingship as the centre of the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Administration of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’s reign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("The theology of the Psalms, Part 2: What is the human being?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One who trusts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Right behaviour: Psalms 15 and 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David as righteous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3"), _c('br'), _c('strong', [_vm._v("THE PSALMS AS PRAYERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9"), _c('span', {
    staticClass: "pad1"
  }, [_vm._v("The tradition of psalmic prayer, Part 1: Opening fully to God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neglect of the Psalms in Christian prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The nature of psalmic prayer: out of the depths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The identity of those who pray the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The elements of psalmic prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A broader identity in prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter09#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10"), _c('span', {
    staticClass: "pad2"
  }, [_vm._v("The tradition of psalmic prayer, Part 2: Psalms that pray for vengeance")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why do we need prayers of vengeance?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guidelines for praying psalms of vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three ‘model’ prayers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The imprecatory psalms and the meaning of ‘vengeance’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Conclusion: The Psalms and Jesus Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Conclusion#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ identity as Son of God and Messiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Conclusion#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baptism, Transfiguration and trial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Conclusion#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffering and death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Conclusion#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurrection of the ‘son of David’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Workscited#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works cited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Copyrightacknowledgements#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright acknowledgements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb19bbd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Contents.vue
// module id = 75
// module chunks = 0